// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app.scss
// module id = 12
// module chunks = 0